var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcPolicyHolder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0373 21.0747C17.0285 21.0747 21.0747 17.0285 21.0747 12.0373C21.0747 7.04615 17.0285 3 12.0373 3C7.04615 3 3 7.04615 3 12.0373C3 17.0285 7.04615 21.0747 12.0373 21.0747Z",
    stroke: "#8A92A6",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0379 12.973C13.7676 12.973 15.1697 11.5709 15.1697 9.84123C15.1697 8.11159 13.7676 6.70944 12.0379 6.70944C10.3083 6.70944 8.90614 8.11159 8.90614 9.84123C8.90614 11.5709 10.3083 12.973 12.0379 12.973Z",
    stroke: "#8A92A6",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1867 18.7031C17.5868 17.5969 16.7005 16.6724 15.6206 16.0264C14.5407 15.3805 13.3069 15.0368 12.0485 15.0314C10.7902 15.0261 9.55351 15.3592 8.46813 15.996C7.38274 16.6327 6.48856 17.5496 5.87927 18.6507",
    stroke: "#8A92A6",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPolicyHolder);
export default __webpack_public_path__ + "static/media/ic_policy_holder.d7a695e498e22bf4a2db474658079081.svg";
export { ForwardRef as ReactComponent };